export default "__VITE_ASSET__Be2fMQAF__"